import { render, staticRenderFns } from "./Part2.vue?vue&type=template&id=f567f9d8&scoped=true&"
import script from "./Part2.vue?vue&type=script&lang=js&"
export * from "./Part2.vue?vue&type=script&lang=js&"
import style0 from "./Part2.vue?vue&type=style&index=0&id=f567f9d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f567f9d8",
  null
  
)

export default component.exports